import Service from "./Service";

import Style from "./Services.module.css";
import { useI18n } from "../../i18n/I18nContext";

const serviceColors = ["#003CA2", "#035DCB", "#00A2FF", "#00CBFF"];

const ServicesSection = () => {
  const { copy } = useI18n();

  return (
    <div className={Style["services-section"]}>
      <div>
        {copy.servicesPage.items.map((service, index) => (
          <Service
            key={service.title}
            title={service.title}
            titleColor={serviceColors[index]}
            description={service.description}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicesSection;
